const bankDetailsReducer = (state = {}, action) => {
    switch (action.type) {
        default:
            return state
    }
};

export default bankDetailsReducer;